module.exports = __webpack_public_path__ + "static/img/wet.4dd8169.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards/matter/wet.png
// module id = CnMg
// module chunks = 1